type CryptoWithOptionalRandomUUID = Pick<Crypto, "getRandomValues"> & {
  randomUUID?: () => string;
};

const UUID_BYTE_LENGTH = 16;

function createRandomUUID(cryptoObject: CryptoWithOptionalRandomUUID): string {
  const randomBytes = new Uint8Array(UUID_BYTE_LENGTH);
  cryptoObject.getRandomValues(randomBytes);

  randomBytes[6] = (randomBytes[6] & 0x0f) | 0x40;
  randomBytes[8] = (randomBytes[8] & 0x3f) | 0x80;

  const hexadecimal = Array.from(randomBytes, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );

  return [
    hexadecimal.slice(0, 8),
    hexadecimal.slice(8, 12),
    hexadecimal.slice(12, 16),
    hexadecimal.slice(16, 20),
    hexadecimal.slice(20, 32),
  ].join("-");
}

export function installRandomUUIDPolyfill(
  cryptoObject: CryptoWithOptionalRandomUUID | undefined = globalThis.crypto
): void {
  if (
    cryptoObject === undefined ||
    typeof cryptoObject.randomUUID === "function" ||
    typeof cryptoObject.getRandomValues !== "function"
  ) {
    return;
  }

  Object.defineProperty(cryptoObject, "randomUUID", {
    configurable: true,
    enumerable: false,
    value: () => createRandomUUID(cryptoObject),
    writable: true,
  });
}
